import "./assets/css/fonts.css";
import "./index.css"; // 
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { routes } from "./routes/allRoutes";
import Layout from "./layout/Index";

// Add viewport meta tag
const addViewportMeta = () => {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) {
    const meta = document.createElement('meta');
    meta.name = "viewport";
    meta.content = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
    document.getElementsByTagName('head')[0].appendChild(meta);
  } else {
    viewport.setAttribute('content', "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no");
  }
};

const Routing = () => {
  // Add viewport meta tag on initial render
  useEffect(() => {
    addViewportMeta();
  }, []);

  return (
    <Routes>
      {routes.map((route, idx) => (
        <Route
          key={idx}
          path={route.path}
          element={<Layout>{route.component}</Layout>}
        />
      ))}
    </Routes>
  );
};

ReactDOM.render(
  <BrowserRouter>
    <Routing />
  </BrowserRouter>,
  document.getElementById("root")
);